import { createRequest } from "helpers/tools";

export const getLeadDestinationId = async (data) => {
    return await createRequest({
        suffix: `lead/connection/${data?.connection_id}/destinations/${data?.destination_id}/fields`,
        method: "get",
        handleError: false,
    });
};

export const reloadDestinationFields = async (data) => {
    return await createRequest({
        suffix: `lead/connection/${data?.connection_id}/destinations/${data?.destination_id}/fields/reload`,
        method: "get",
        handleError: false,
    });
};

export const getLeadHubspotAuthURL = async () => {
    return await createRequest({
        suffix: `lead/service/hubspot/auth-url`,
        handleError: true,
        method: "get",
    });
};

export const getLeadHubspotDestinations = async () => {
    return await createRequest({
        suffix: `lead/service/hubspot/list`,
        handleError: true,
        method: "get",
    });
};

export const postLeadCreateHubspot = async (payload) => {
    return await createRequest({
        suffix: `lead/service/hubspot/store`,
        handleError: true,
        method: "post",
        payload,
    });
};

export const getHubspotModules = async () => {
    return await createRequest({
        suffix: `lead/service/hubspot/modules`,
        handleError: true,
        method: "get",
    });
};

export const getLeadHubspotAuthURLWithModule = async (module) => {
    return await createRequest({
        suffix: `lead/service/hubspot/auth-url?module=${module}`,
        handleError: true,
        method: "get",
    });
};

export const getDestinationsByConnectionId = async (connection_id) => {
    return await createRequest({
        suffix: `lead/destinations?filter_with_connection=${connection_id}`,
        handleError: true,
        method: "get",
    });
};
